<section class="experience-section section">
    <div class="container">
        <div class="row">
            <div class="col-sm-4">
                <div class="heading">
                    <h3><b>Trabalho Remoto</b></h3>
                    <h6 class="font-lite-black"><b>OPINIÃO</b></h6>
                </div>
            </div><!-- col-sm-4 -->
            <div class="col-sm-8" *ngIf="!exibirAlerta">
                
                <form [formGroup]="pesquisaForm" (ngSubmit)="onSubmit()">

                    <div class="experience margin-b-50">
                        <h4><b>PRODUTIVIDADE</b></h4>
                        <h5 class="font-yellow"><b>Com trabalho remoto sua produtividade:</b></h5>

                        <div class="form-group">

                            <select class="form-control" id="nivelProdutividade" formControlName="nivelProdutividade" required>
                                <option [value]="2">Aumentou muito</option>
                                <option [value]="1">Aumentou</option>
                                <option [value]="0" selected>Não teve alteração</option>
                                <option [value]="-1">Diminuiu</option>
                                <option [value]="-2">Diminuiu muito</option>
                            </select>
                            
                        </div>

                        <h5 class="font-yellow"><b>Com relação a envolvimentos rotineiros, como reuniões, cerimônias ageis, etc:</b></h5>

                        <div class="form-group">

                            <select class="form-control" id="nivelEnvolvimento" formControlName="nivelEnvolvimento" required>
                                <option [value]="2">Processo foi otimizado e somente as pessoas necessárias são envolvidas</option>
                                <option [value]="1">Estão sendo mais rápidas que as presenciais</option>
                                <option [value]="0" selected>Não teve alteração</option>
                                <option [value]="-1">Estão sendo mais lentas que as presenciais</option>
                                <option [value]="-2">Processo piorou e estou sendo envolvidos em reuniões que não sou necessário</option>
                            </select>
                            
                        </div>
                    
                    </div><!-- experience -->


                    <div class="experience margin-b-50">
                        <h4><b>RECURSOS</b></h4>
                        
                        <h5 class="font-yellow"><b>Com relação aos recursos como hardware e software (de áudio, vídeo conferência, mensagens, etc) :</b></h5>

                        <div class="form-group">

                            <select class="form-control" id="nivelRecursos" formControlName="nivelRecursos" required>
                                <option [value]="2">Atende todas as necessidades e ainda tem recursos que facilitam o trabalho a distância</option>
                                <option [value]="1">Atende todas as necessidades</option>
                                <option [value]="0" selected>Atende as necessidades básicas</option>
                                <option [value]="-1">Atende parcialmente, faltam alguns recursos</option>
                                <option [value]="-2">Não atende e tenho que utilizar recursos pessoais para trabalhar</option>
                            </select>
                            
                        </div>

                    </div><!-- experience -->

                    <div class="experience margin-b-50">
                        <h4><b>OPINIÃO</b></h4>

                        <h5 class="font-yellow"><b>Com a experiência adquirida nos dias de home office full time, você acredita que após o término da crise, sua empresa deveria:</b></h5>

                        <div class="form-group">

                            <select class="form-control" id="nivelAdocaoFutura" formControlName="nivelAdocaoFutura" required>
                                <option [value]="2">Adotar home office full time e o trabalho presencial esporadicamente</option>
                                <option [value]="1">Adotar ao menos 2 dia na semana home office</option>
                                <option [value]="0" selected>Voltar ao trabalho 100% presencial</option>
                            </select>
                            
                        </div>

                        <h5 class="font-yellow"><b>No geral, sua experiência com home office em comparação ao trabalho presencial foi (ou está sendo):</b></h5>

                        <div class="form-group">

                            <select class="form-control" id="nivelExperiencia" formControlName="nivelExperiencia" required>
                                <option [value]="2">Muito melhor</option>
                                <option [value]="1">Melhor</option>
                                <option [value]="0" selected>Indiferente</option>
                                <option [value]="-2">Pior</option>
                                <option [value]="-1">Muito Pior</option>
                            </select>
                            
                        </div>

                        <button type="submit" class="btn">Submit</button>

                    
                    </div><!-- experience -->
                </form>
                
            </div><!-- col-sm-8 -->

            <div class="col-sm-8" *ngIf="exibirAlerta">
                <div class="experience margin-b-50">
                    <h4><b>{{mensagemResposta}}</b></h4>
                    <h5 class="font-yellow"><b>{{mensagemRespostaDetalhe}}</b></h5>
                    <a href="/"><button class="btn">Home</button></a>             
                </div><!-- experience -->
            </div><!-- col-sm-8 -->

        </div><!-- row -->
    </div><!-- container -->
    
</section><!-- experience-section -->
